/*!
 * Copyright (c) 2017-present Ghostery GmbH. All rights reserved.
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */
/* eslint-disable prettier/prettier */
export default [
    ",ipaddress=/^(1(72\\.67\\.\\d{3}|04\\.21\\.\\d+)\\.\\d+|188\\.114\\.9[67]\\.[08]|64:ff9b::[a-f0-9]{4}:[a-f0-9]{1,4})$/,replace='/^/<script>(()=>{window.open=new Proxy(window.open,{apply:(n,o,w)=>{}});let e=document.querySelector(\"script\");e.innerHTML.includes(\"window.open\")&&e.parentElement.removeChild(e)})();<\\/script>/i'",
    "\\/(?:assets|build|bundles|chunks|dist|files|j|public|scripts|static)?\\/?(?:js\\/)?[0-9_a-z]{6,16}\\/?[0-9_a-z]{5,120}(?:[-.](?:app|bundle|ma?in|module|prod|index|v\\d|vendor))?(?:\\.js)?(?:\\?r=\\d)?$/$script,3p,match-case,",
    "~adatoolbar.com|~aswpsdkus.com|~chimpstatic.com|~clickiocmp.com|~mojirater.com|~polldaddy.com|~squareoffs.com|~succeedscene.com|~tallysight.com|~veraviews.com,",
    "/^https:\\/\\/(?:www\\d\\.)?[-a-z]{6,}\\.(?:club|com|info|net|org)\\/(?=[-_a-zA-Z]{0,42}\\d)(?=[-_0-9a-z]{0,42}[A-Z])[-_0-9a-zA-Z]{43}\\/\\?",
    "/^https:\\/\\/s[cfntz]y?[ace][acemnu][a-z]{1,4}or?[mn][a-z]{4,8}[iy][a-z]?\\.",
    "*&iu=%2F18190176%2C22509719621%2FAdThrive_Video_",
    "/(\\d{0,1})?tamilprint(\\d{1,2})?\\.[a-z]{3,7}/##",
    "/pagead/managed/js/gpt/*/pubads_impl",
    "[-.][-a-z0-9][-a-z0-9]+\\.[a-z]+\\//",
    "[0-9a-z][0-9a-z][0-9a-z][0-9a-z]",
    "/extensions/*/AppMeasurement",
    "/pagead/js/adsbygoogle.js",
    "/js/sdkloader/ima3.js",
    "/js/sdkloader/ima3_d",
    "/videojs-contrib-ads",
    "/wp-content/plugins/",
    "/wp-content/uploads/",
    "/public/widget/data",
    "/wp-content/themes/",
    "/detroitchicago/",
    "/appmeasurement",
    "/cdn-cgi/trace",
    "\\/[a-zA-Z0-9]{",
    "/^https?:\\/\\/",
    "[0-9a-f]{32}",
    "/^https:\\/\\/",
    "notification",
    "fingerprint",
    "/413gkwmt/",
    "/affiliate",
    "impression",
    "[a-z0-9]{",
    "/plugins/",
    "analytics",
    "telemetry",
    "[a-f0-9]",
    "/assets/",
    "/images/",
    "tracking",
    "/public",
    "300x250",
    "ampaign",
    "captcha",
    "collect",
    "consent",
    "content",
    "counter",
    "metrics",
    "/media",
    "banner",
    "bundle",
    "client",
    "cookie",
    "google",
    "module",
    "rivacy",
    "script",
    "source",
    "widget",
    ".aspx",
    ".cgi?",
    ".html",
    "[a-z]",
    "/api/",
    "/beac",
    "/java",
    "/stat",
    "a-z]{",
    "block",
    "click",
    "count",
    "event",
    "fault",
    "frame",
    "manag",
    "pixel",
    "theme",
    "track",
    "type=",
    "video",
    "visit",
    ".com",
    ".gif",
    ".jpg",
    ".min",
    ".php",
    ".png",
    "[0-9",
    "/img",
    "/jqu",
    "/js/",
    "/lib",
    "/log",
    "/v1/",
    "/web",
    "/wp-",
    "468x",
    "http",
    "mail",
    "sync",
    "tect",
    "uild",
    "view",
    ".js",
    "(?:",
    "/ad",
    "%2f",
    "%2F",
    "=*&",
    "age",
    "dpr",
    "jax",
    "key",
    "lay",
    "log",
    "new",
    "sdk",
    "tag",
    "web",
    "-p",
    ":/",
    "*/",
    "/_",
    "/?",
    "/*",
    "/d",
    "/f",
    "/g",
    "/h",
    "/l",
    "/m",
    "/n",
    "/p",
    "/r",
    "/u",
    "/w",
    "\\.",
    "\\/",
    "00",
    "a-",
    "ab",
    "ac",
    "ad",
    "al",
    "am",
    "an",
    "ap",
    "ar",
    "at",
    "ce",
    "ch",
    "co",
    "de",
    "di",
    "e/",
    "ed",
    "el",
    "en",
    "er",
    "et",
    "fi",
    "ic",
    "id",
    "im",
    "in",
    "it",
    "js",
    "le",
    "li",
    "lo",
    "mp",
    "o/",
    "ol",
    "om",
    "on",
    "op",
    "or",
    "ot",
    "re",
    "ro",
    "s_",
    "s-",
    "s?",
    "s/",
    "se",
    "sh",
    "si",
    "sp",
    "ss",
    "st",
    "t/",
    "te",
    "ti",
    "tm",
    "tr",
    "ub",
    "un",
    "up",
    "ur",
    "ut",
    "ve",
    "_",
    "-",
    ",",
    "?",
    ".",
    ")",
    "[",
    "{",
    "}",
    "*",
    "/",
    "\\",
    "&",
    "%",
    "^",
    "=",
    "|",
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z"
];
//# sourceMappingURL=network-filter.js.map